import React, { forwardRef } from 'react';
import { Widget, SortableWidgetProps } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { RecommendationDto } from '../../../../services/dtos/issuer/recommendation.dto';
import { useGlobalModalContext } from '../../../GlobalModal';
import { MODAL_TYPES } from '../../../GlobalModal/GlobalModal';
import WeightIcon from '../../../WeightIcon';
import CSViewWidgetContent from '../CSViewWidgetContent';
import styles from './CSViewCompanyWidget.module.scss';

const cx = classNames.bind(styles);

interface CSViewCompanyWidgetProps extends SortableWidgetProps {
  issuerTag: string;
  noPrint?: boolean;
  recommendation?: RecommendationDto;
}

const CSViewCompanyWidget = (
  { issuerTag, recommendation, noPrint, ...sortableWidgetProps }: CSViewCompanyWidgetProps,
  ref
): React.ReactElement => {
  const { showModal } = useGlobalModalContext();

  const onClick = () => {
    showModal(MODAL_TYPES.CS_VIEW);
  };

  return (
    <div className={cx('body', { 'no-print': noPrint })}>
      <Widget
        headerTitle="CS View"
        headerTooltip={{ tooltipText: 'More on CS View', onClick }}
        dataTestId="cs-view-company"
        firstLine={recommendation?.weighting ? <WeightIcon weighting={recommendation.weighting} /> : undefined}
        ref={ref}
        {...sortableWidgetProps}
      >
        <div className={cx('print-body')}>
          {recommendation?.weighting && (
            <div className={cx('print-icon')}>
              <WeightIcon weighting={recommendation.weighting} />
            </div>
          )}
          <CSViewWidgetContent
            data={recommendation}
            issuerTag={issuerTag}
            showLinkToCompany={false}
            truncateContent={false}
          />
        </div>
      </Widget>
    </div>
  );
};

export default forwardRef(CSViewCompanyWidget);
